import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// ANT DESIGN
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Col,
  Divider,
  Spin,
  DatePicker,
  InputNumber,
} from "antd";

//ANT DESIGN ICONS IMPORT
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from "dayjs";

// PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from "../../../../../components/custom/CustomButton";
import styles from "../../../../../assets/styles/styles";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const CloseCurrentAcc = (props) => {
  const { Text } = Typography;
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dateFormat = "YYYY/MM/DD";
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    getTemplate();
    getDetailById();
    defaultDate();
  }, []);

  function onCancel() {
    navigate("/detail-current-account", { state: state });
  }
  const handleOnChange = (value) => {
    setIsSelected(value);
  };
  const defaultDate = () => {
    useForm.setFieldsValue({
      closedOnDate: dayjs(),
    });
  };
  const [ghost, setGhost] = useState(null);
  const Items = [
    {
      key: "1",
      label: "Show Payment Details",
      children: (
        <>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="accountNumber"
                label={<Text style={{ fontSize: "16px" }}>{labelConfig.accountNumber}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="checkNumber"
                label={<Text style={{ fontSize: "16px" }}>{labelConfig.chequeNumber}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chequeNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="routingCode"
                label={<Text style={{ fontSize: "16px" }}>{labelConfig.routingCode}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.routingCode,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="receiptNumber"
                label={<Text style={{ fontSize: "16px" }}>{labelConfig.receiptNumber}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.receiptNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="bankNumber"
                label={<Text style={{ fontSize: "16px" }}>{labelConfig.bank}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.bank, labelConfig.pleaseEnter)}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  function getTemplate() {
    const url = `${apiConfig.savingsAccounts}/${state.id}/transactions/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentType = [];

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypeData(tempPaymentType);
        setIsLoading(false);
      }
    });
  }

  const getDetailById = () => {
    const params = {
      associations: "all",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        useForm.setFieldsValue({
          transactionAmount: objDetail.summary?.availableBalance,
        });

        setIsLoading(false);
      }
    });
  };
  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };
  const onSubmit = (formValues) => {
    delete formValues.transactionAmount;
    const url = `${apiConfig.savingsAccounts}/${state.id}`;
    const params = {
      command: "close",
    };

    const body = {
      withdrawBalance: formValues.withdrawBalance,
      postInterestValidationOnClosure: formValues.postInterestValidationOnClosure,
      paymentTypeId: formValues.paymentTypeId,
      closedOnDate: BOM.DateTime(formValues.closedOnDate, "only-date"),
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.customerClosureMsg);
        navigate("/detail-current-account", {
          state: { ...state, statusValue: accountStatus.closed },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.closeCurrentAcc}
        pageItems={staticConfig.closeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
            initialValues={{
              withdrawBalance: false,
              postInterestValidationOnClosure: true,
            }}
          >
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.closedOn}
                  name="closedOnDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledAfterCurrentDate}
                    style={{ width: "100%", height: 35 }}
                    format={dateFormat}
                  />
                </Form.Item>
              </Col>
              {isSelected && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.transactionAmount}
                      name="transactionAmount"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.transactionAmount),
                        },
                      ]}
                    >
                      <InputNumber
                        disabled
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"
                        formatter={BOM.FormatAmount}
                        parser={BOM.ParseAmount}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.paymentTypes} name="paymentTypeId">
                      <Select
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                        }
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.paymentTypes, "select")}
                        options={paymentTypeData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </>
              )}

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="withdrawBalance" label="Withdraw Balance">
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.withdrawBalance, "select")}
                    onChange={handleOnChange}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.isInterestPostingRequiredOnClosureDate}
                  name="postInterestValidationOnClosure"
                  initialValue={true}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.isInterestPostingRequiredOnClosureDate),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.isInterestPostingRequiredOnClosureDate,
                      "select"
                    )}
                    options={staticConfig.isInterestPostingRequiredOnClosureDate}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name="note">
                  <TextArea placeholder={BOM.handlePlaceholderMsg(labelConfig.note)} />
                </Form.Item>
              </Col>

              {isSelected && (
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Collapse
                    ghost={ghost}
                    items={Items}
                    bordered={false}
                    expandIconPosition={"end"}
                    style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
                    expandIcon={({ isActive }) => {
                      {
                        isActive ? setGhost(false) : setGhost(true);
                      }
                      return (
                        <>
                          {isActive ? (
                            <MinusOutlined
                              style={{
                                backgroundColor: "#15CCAE",
                                color: "white",
                                padding: 8,
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <PlusOutlined
                              style={{
                                backgroundColor: "#15CCAE",
                                color: "white",
                                padding: 8,
                                borderRadius: 10,
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  />
                </Col>
              )}
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default CloseCurrentAcc;
